<template>
    <i class="fa fa-envelope fa-lg"
        aria-hidden="false"
        :title="uLang('app.resend_invoice')"
        @click="resendInvoice"
    ></i>
</template>

<script>
    import { ConfirmationAlert } from '~/Swals'

    export default {
        name: 'ResendInvoiceButton',

        props: {
            invoiceId: {
                type: Number,
                required: false,
            },
        },

        computed: {
            invoiceType() {
                return 'app.' + this.type + '_invoice';
            }
        },

        methods: {
            resendInvoice() {
                new ConfirmationAlert({
                    text: this.uLang('app.confirm_send_invoice', { entity: this.uLang(this.invoiceType) }),
                }).show().then(async () => {
                    const {data} = await window.axios.post(route('invoices.resend', { invoice: this.invoiceId }));

                    if (data.message === 'success') {
                        this.bookingSuccess(data)
                    } else if (data.message === 'error') {
                        this.bookingError(data)
                    } else {
                        this.$snotify.error(data.message);
                    }
                })
            },

            bookingSuccess(data) {
                this.$snotify.info(uLang('app.successfully_resent_invoice', {entity: this.uLang(this.invoiceType)}));
                vue.$emit('reloadTable');
                vue.$emit('unbookedInvoicesMayChange');
            },

            bookingError(data) {
                this.$snotify.error(uLang('app.error_resent_invoice', { entity: this.lang(this.invoiceType) }));
            },
        },
    }
</script>
